/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { array, lazy, object, Schema } from '../schema';
import { Offer, offerSchema } from './offer';

export interface Data6 {
  offer: Offer[];
}

export const data6Schema: Schema<Data6> = object({
  offer: ['Offer', array(lazy(() => offerSchema))],
});
